module.exports = __webpack_public_path__ + "static/media/1.35be143a.png";